import { isPlainObject } from './is'

function objForEach(obj: any, fn: (v: any, k: string) => void) {
  if (isPlainObject(obj) === false) {
    return
  }

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      fn.call(null, obj[key], key)
    }
  }
}

/**
 * 深度合并对象
 * @param args
 * @returns
 */
export function merge(...args: any[]) {
  const result: Recordable = {}

  function assignValue(val: any, key: string) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val)
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val)
    } else if (Array.isArray(val)) {
      result[key] = val.slice()
    } else {
      result[key] = val
    }
  }

  for (let i = 0, l = args.length; i < l; i++) {
    objForEach(args[i], assignValue)
  }
  return result
}
